////////LIBRARY/////////
import { find, isUndefined, map } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import styled from 'styled-components'
///////COMPONENTS///////
import { HeaderCells, HeaderCellsSticky, TableHeaderWrapper } from '../../../../theme/GlobalCss'
import TooltipHelp from '../../../TooltipHelp'
import IsAction from '../IsAction'
import IsVisible from '../IsVisible'
import SortableImage from '../TableHeader/SortableImage'
import TableRows from '../TableRows'
/////////ASSETS/////////
import nestedDropDownIcon from '../../../../assets/icones/table/nested-dropdown-all.svg'

/////////STYLED/////////
const ToggleAllNestedWrapper = styled(HeaderCells)`
	width: min-content;
	& > img {
		display: block;
		cursor: pointer;
		transform: ${(props) => (props.dropped ? 'rotate(180deg)' : 'rotate(0deg)')};
	}
`
/////////STYLED/////////

const TableNestedHeader = ({
	columns,
	sortTable,
	data,
	setValue,
	hasNestedValues,
	setToggleAllNestedHandler,
	toggleAllNestedHandler,
	nestedTheme = true,
}) => {
	const { translations, user } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TableHeaderWrapper>
			<TableRows>
				{hasNestedValues && !isUndefined(setToggleAllNestedHandler) && (
					<ToggleAllNestedWrapper onClick={() => setToggleAllNestedHandler()} dropped={toggleAllNestedHandler}>
						<img src={nestedDropDownIcon} />
					</ToggleAllNestedWrapper>
				)}
				{map(columns, (column, id) => {
					let actionAuthorized = true

					const f = find(user.identity.rolePrivileges.privileges, (o) => o.label === column.checkRight) ? true : false
					if (!isUndefined(column.checkRight) && !f && column.action) {
						actionAuthorized = false
					}

					if (!isUndefined(column.boolRight) && !column.boolRight) {
						actionAuthorized = false
					}
					return actionAuthorized ? (
						<IsVisible key={id} isVisible={column.visibility}>
							{/* Check if action column is mapped with a right, so we test it*/}
							<IsAction
								data={{ column: column, action: sortTable }}
								isAction={column.action || false}
								actionCell={() => (
									<HeaderCellsSticky nestedTheme={nestedTheme}>{translations['common__text__tab_actions']}</HeaderCellsSticky>
								)}
								normalCell={(data) => (
									<HeaderCells onClick={() => data.action(data.column.headerName)} nestedTheme={nestedTheme}>
										{data.column.tooltipHelp ? (
											<TooltipHelp
												content={data.column.tooltipHelp.content}
												insideModal={data.column.tooltipHelp.insideModal || false}
											>
												{data.column.headerName}
											</TooltipHelp>
										) : (
											data.column.headerName
										)}
										{data.column.sortable && <SortableImage nestedTheme />}
									</HeaderCells>
								)}
							/>
						</IsVisible>
					) : null
				})}
			</TableRows>
		</TableHeaderWrapper>
	)
}

TableNestedHeader.propTypes = {
	columns: PropTypes.array.isRequired,
}

TableNestedHeader.defaultPropTypes = {
	columns: [],
}

export default TableNestedHeader
